module.exports = __webpack_public_path__ + "static/media/6-3.e1f93899.mp3";